import { combineReducers } from '@reduxjs/toolkit';

import accountsSlice, * as fromAccounts from './accountSlice';
import accountUsersSlice, * as fromAccountUsers from './accountUsersSlice';
import authReducer, * as fromAuth from './authSlice';
import billingInformationSlice, * as fromBillingInformation from './billingInformationSlice';
import invoiceSlice, * as fromInvoices from './invoiceSlice';
import layoutSlice, * as fromLayout from './layoutSlice';
import orderReducer, * as fromOrder from './orderSlice';
import paymentMethodSlice, * as fromPaymentMethod from './paymentMethodSlice';
import subscriptionReducer, * as fromSubscription from './subscriptionSlice';
import surveyReducer, * as fromSurvey from './surveySlice';
import organizationsReducer, * as fromOrganizations from './organizationsSlice';
import promotionReducer, * as fromPromotion from './promotionSlice';
import couponReducer, * as fromCoupon from './couponSlice';

const rootReducer = combineReducers({
  [fromAccountUsers.ACCOUNT_USERS_FEATURE_KEY]: accountUsersSlice,
  [fromAccounts.ACCOUNT_FEATURE_KEY]: accountsSlice,
  [fromAuth.AUTH_FEATURE_KEY]: authReducer,
  [fromBillingInformation.BILLING_INFORMATION_FEATURE_KEY]: billingInformationSlice,
  [fromInvoices.INVOICE_FEATURE_KEY]: invoiceSlice,
  [fromLayout.LAYOUT_FEATURE_KEY]: layoutSlice,
  [fromOrder.ORDER_FEATURE_KEY]: orderReducer,
  [fromPaymentMethod.PAYMENT_METHOD_FEATURE_KEY]: paymentMethodSlice,
  [fromSubscription.SUBSCRIPTION_FEATURE_KEY]: subscriptionReducer,
  [fromSurvey.SURVEY_FEATURE_KEY]: surveyReducer,
  [fromOrganizations.ORGANIZATION_FEATURE_KEY]: organizationsReducer,
  [fromPromotion.PROMOTION_FEATURE_KEY]: promotionReducer,
  [fromCoupon.COUPON_FEATURE_KEY]: couponReducer,
});

export {
  fromAccounts,
  fromAccountUsers,
  fromAuth,
  fromBillingInformation,
  fromInvoices,
  fromLayout,
  fromOrder,
  fromPaymentMethod,
  fromSubscription,
  fromSurvey,
  fromOrganizations,
  fromPromotion,
  fromCoupon,
};
export default rootReducer;
